export default __webpack_public_path__ + "static/tokkyu_600-4091776571f1057ca9041c1841801464.jpg";